export const getSignatureFromRental = (rental, signatureType) => {
  if (!rental) {
    return {};
  }
  const rentalSignature = rental.rentalSignatures?.find((signature) => {
    return signature.signatureType === signatureType;
  });
  return rentalSignature || {};
};
